<template>
  <div
    class="alert"
    :class="{ [`alert--${color}`]: color, 'alert--lg': isLarge }"
  >
    <v-cancel
      v-if="isDismissible"
      class="alert__dismiss"
      @click="$emit('dismiss')"
    />
    <v-icon
      v-if="icon"
      class="alert__icon"
      :type="icon"
    />
    <div class="alert__inner">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
  import Cancel from '@/atoms/Cancel';
  import Icon from '@/atoms/Icon';
  export default {
    components: {
      "v-cancel": Cancel,
      "v-icon": Icon,
    },
    props: {
      icon: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: null
      },
      isLarge: {
        type: Boolean,
        default: false
      },
      isDismissible: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";
  .alert {
    $this: &;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: .5rem 1rem;
    border-radius: $border-radius;
    border: 1px solid $pigeon;
    background-color: $selago;
    &__icon {
      margin-right: .5rem;
    }
    &__dismiss {
      order: 1;
      margin-left: auto;
    }
    &__inner {
      word-break: break-word;
    }
    &--lg {
      padding: 1rem 2rem;
      flex-direction: column;
      font-size: $font-size-lg;
      #{$this}__icon {
        font-size: 3rem;
        line-height: 1;
        margin-right: 0;
        margin-bottom: .5rem;
      }
    }
    &--error {
      border-color: $guardsman;
      color: $guardsman;
      background-color: mix($white, $guardsman, 95%);
    }
    &--success {
      border-color: $green;
      color: $green;
      background-color: mix($white, $green, 95%);
    }
  }
</style>
